<template>
    <div class="receive-form">
        <div class="mail-types">
            <div class="btn-group" role="group">
                <button
                    class="btn btn-lg"
                    :class="{
                        'btn-success': _type.id == mail.typeId,
                        'btn-secondary': _type.id !== mail.typeId,
                    }"
                    :key="_type.id"
                    v-for="_type in mailTypes"
                    @click="mail.typeId = _type.id"
                >
                    <i
                        class="fa"
                        v-if="!!_type.fa_class"
                        :class="_type.fa_class"
                    ></i>
                    {{ _type.name }}
                </button>
            </div>
            <span v-if="$v.mail.typeId.$error" class="field-error"
                >Debe seleccionar un tipo de correspondencia</span
            >
        </div>
        <div class="destination">
            <app-autocomplete
                placeholder="Dirigido a:"
                :items="destinations"
                label-prop="destination"
                v-model="destination"
                :has-error="$v.mail.destinationId.$error"
                error-message="Debe seleccionar el destino de la correspondencia"
                @change="$v.mail.destinationId.$touch()"
            />
        </div>
        <div class="form-group">
            <label for="notes">Notas</label>
            <textarea
                name="notes"
                id="notes"
                cols="30"
                rows="4"
                class="form-control"
                v-model="mail.notes"
            ></textarea>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="card-text">
                    <app-upload-or-take-photo
                        id="mail-photos"
                        title="Fotos de correspondencia"
                        v-model="files"
                    />
                    <div v-if="files">
                        <button
                            class="btn btn-sm btn-danger pull-right"
                            @click="cancelFilesSelected"
                        >
                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                            Cancelar archivos seleccionados
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vigilanceRepository from '../../../../../repositories/vigilance.repository'
import Autocomplete from '../../../../UI/Controls/AutocompleteV3/Autocomplete.vue'
import autocompleteRepository from '../../../../../repositories/autocomplete.repository'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { alphaNumericNoSpacesNotDot } from '../../../../../utils/CustomValidators'
import UploadOrTakePhoto from '../../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import repo from '../../../../../repositories/repo'

export default {
    components: {
        appAutocomplete: Autocomplete,
        appUploadOrTakePhoto: UploadOrTakePhoto,
    },
    props: {
        onSave: {
            type: Function,
        },
    },
    data() {
        return {
            mail: {
                destinationId: '',
                ownerId: '',
                typeId: '',
                notes: '',
            },
            destination: '',
            files: '',
            peopleAndStructures: [],
            destinations: [],
        }
    },
    watch: {
        destination(val) {
            if (!val) return

            this.mail.destinationId = val.structure_id
            this.mail.ownerId = 'person' === val.type ? val.person_id : ''
            // if (!val) {
            //     this.mail.ownerId = ''
            //     this.mail.destinationId = ''
            // } else if (!!val.structure_type) {
            //     //Estructura
            //     this.mail.destinationId = val.id
            // } else {
            //     //Persona
            //     this.mail.ownerId = val.id
            //     this.mail.destinationId = val.structure_id
            // }
        },
    },
    validations: {
        mail: {
            destinationId: { required },
            typeId: { required },
        },
    },
    computed: {
        ...mapGetters(['mailTypes']),
    },
    methods: {
        ...mapActions(['receiveMail']),
        loadPepleOrStructures() {
            if (!this.client) return

            autocompleteRepository
                .searchPeopleOrStructures(this.client.id, '')
                .then(data => (this.peopleAndStructures = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrio un error al buscar en personas o estructuras'
                    )
                )
        },
        saveMail() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return false
            }

            const formData = new FormData()

            formData.append('destinationId', this.mail.destinationId)
            formData.append('ownerId', this.mail.ownerId)
            formData.append('typeId', this.mail.typeId)
            formData.append('notes', this.mail.notes)

            formData.append('structureId', this.accessPoint.id)
            formData.append('clientId', this.client.id)
            formData.append('userId', this.user.id)

            if (this.files.photos) {
                this.files.photos.map(item => formData.append('photos[]', item))
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append('file' + index, item)
                )
            }

            // Apagar camara al recibir la correspondencia
            this.$bus.$emit('webcam.off')

            const vr = Object.assign({}, vigilanceRepository)
            vr.receiveMail(formData)
                .then(item => {
                    this.$v.$reset()
                    toastr.success(
                        'Correspondencia ingresada satisfactoriamente'
                    )
                    this.$bus.$emit('receive-mail-destination.reset')
                    Object.keys(this.mail).map(key => (this.mail[key] = ''))
                    typeof this.onSave === 'function' && this.onSave()
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al ingresar la correspondencia'
                    )
                })
        },
        cleanFields() {
            Object.keys(this.mail).map(key => (this.mail[key] = ''))
            this.destination = ''
            this.$v.$reset()
            this.$bus.$on('receive-form.clean', this.cleanFields)
            this.$bus.$emit('receive-mail-destination.reset')
            this.files = ''

            this.$bus.$emit('mail-photos.clean')
        },
        cancelFilesSelected() {
            this.$bus.$emit('mail-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        async loadDestinations() {
            const { data } = await repo.get(
                `venues/${this.accessPoint.venue_id}/destinations`
            )
            this.destinations = data
        },
    },
    created() {
        this.cleanFields()
        this.load('mailTypes')
        // this.loadPepleOrStructures()

        this.$bus.$on('receive-mail.save', () => {
            this.saveMail()
        })
        this.loadDestinations()
    },
    beforeDestroy() {
        this.$bus.$off('receive-mail.save')
    },
}
</script>
